export default class CampaignConsentTerm {

	constructor() {
		this.id = 0;
		this.campaignId = 0;
		this.paymentMethodId = 0;
		this.term = "";
	}
}